import React from "react";

const shimmer = { background: "linear-gradient(90deg, #EFEFEF 25%, #F7F7F7 50%, #EFEFEF 75%)", backgroundSize: "200% 100%", animation: "cd-shimmer 1.2s ease-in-out infinite", borderRadius: 8 };

export const SkeletonBlock = ({ h = 16, w = "100%", style }) => <div style={{ height: h, width: w, ...shimmer, ...style }} />;

export function TableSkeleton({ rows = 8, cols = 5, testId = "loading-skeleton" }) {
  return (
    <div className="card-cd" data-testid={testId} aria-busy="true" style={{ padding: 0, overflow: "hidden" }}>
      <div className="flex gap-4" style={{ padding: "14px 18px", borderBottom: "1px solid #EEE" }}>
        {Array.from({ length: cols }).map((_, i) => <SkeletonBlock key={i} h={12} w={`${100 / cols}%`} />)}
      </div>
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className="flex gap-4 items-center" style={{ padding: "16px 18px", borderBottom: "1px solid #F3F3F3" }}>
          {Array.from({ length: cols }).map((_, c) => <SkeletonBlock key={c} h={14} w={`${100 / cols}%`} style={{ opacity: 1 - r * 0.08 }} />)}
        </div>
      ))}
    </div>
  );
}

export function StatsSkeleton({ count = 4, testId = "loading-skeleton" }) {
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4" data-testid={testId} aria-busy="true">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="card-cd" style={{ padding: 18 }}>
          <SkeletonBlock h={10} w="55%" />
          <SkeletonBlock h={26} w="40%" style={{ marginTop: 14 }} />
          <SkeletonBlock h={10} w="35%" style={{ marginTop: 10 }} />
        </div>
      ))}
    </div>
  );
}

export function PageSkeleton() {
  return (
    <div data-testid="page-skeleton" aria-busy="true">
      <SkeletonBlock h={28} w={220} />
      <SkeletonBlock h={14} w={320} style={{ marginTop: 10, marginBottom: 24 }} />
      <StatsSkeleton />
      <div style={{ marginTop: 24 }}><TableSkeleton rows={6} /></div>
    </div>
  );
}

export function ErrorState({ message, onRetry, testId = "error-state" }) {
  return (
    <div className="card-cd" data-testid={testId} role="alert" style={{ padding: "36px 24px", textAlign: "center", color: "#7A1F1F", background: "#FFF5F5", border: "1px solid #FCD5D5" }}>
      <i className="fa-solid fa-triangle-exclamation" style={{ fontSize: 22, marginBottom: 10 }} />
      <div style={{ fontWeight: 600, fontSize: 14 }}>{message}</div>
      {onRetry && <button type="button" className="btn-glass-cd" onClick={onRetry} data-testid="error-retry" style={{ marginTop: 14 }}>Try again</button>}
    </div>
  );
}
